import { Component, inject, Input } from '@angular/core';
import { FormArray, FormBuilder, FormGroup, Validators } from '@angular/forms';
// import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { BrowserStorageService } from '../../../../shared/services/common/browser-storage.service';
import { ApiCallsService } from '../../../../shared/services/network/api-calls.service';
import { fileDirectories } from '../../../../utils/view-settings';

import { CommonModule } from '@angular/common';
import { NgbActiveModal, NgbActiveOffcanvas, NgbModule, NgbTooltipModule } from '@ng-bootstrap/ng-bootstrap';
import { BsDatepickerModule } from 'ngx-bootstrap/datepicker';
import { api } from '../../../../utils/endpoints';

import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';

import { NgSelectModule } from '@ng-select/ng-select';
import { NoWhitespaceValidator } from '../../../../shared/validators/custom.validator';

import { DragDropModule } from '@angular/cdk/drag-drop';
import { SafeHtmlPipe } from '../../../../shared/validators/safe-html.pipe';
import { ICONS } from '../../../../utils/svg-icons';

@Component({
  selector: 'app-edit-feed',
  standalone: true,
  imports: [
    NgbModule,
    CommonModule,
    BsDatepickerModule,
    FormsModule,
    ReactiveFormsModule,
    NgSelectModule,
    DragDropModule,
    NgbTooltipModule,
    SafeHtmlPipe,
  ],
  templateUrl: './edit-feed.component.html',
  styleUrl: './edit-feed.component.scss',
  providers: [NgbActiveModal], // ✅ Add provider here
})
export class EditFeedComponent {
  showError = false;
  userInfo: any;
  maxDate: Date = new Date();
  minDate: any;
  sportsForm!: FormGroup;
  sportList: any = [];
  levelList: any = [];
  selectedSport = 1;
  page = 1;
  ICONS = ICONS;

  fileDirectoriesPath: any = fileDirectories.profile;
  @Input() public feedDetails: any;

  activeModal = inject(NgbActiveModal); // ✅ Use inject() for Standalone Components
  constructor(
    private _toastr: ToastrService,
    private _apiService: ApiCallsService,
    private fb: FormBuilder,
    private _storageService: BrowserStorageService,

    public activeOffcanvas: NgbActiveOffcanvas,
  ) {}

  ngOnInit(): void {
    const userdata = this._storageService.getItem('userDetail');
    if (userdata && userdata != undefined) {
      this.userInfo = JSON.parse(userdata);
      this.minDate = new Date(this.userInfo?.dateOfBirth);
      this.minDate.setDate(this.minDate.getDate() + 1); // Add 1 day
    }
    this.sportsForm = this.fb.group({
      sportsDetails: this.fb.array([]),
    });

    this.sportsDetails.push(this.createSportForm(this.feedDetails));
    this.feedDetails.postMedias.map((data: any) => {
      const sportGroup = this.sportsDetails.at(0) as FormGroup;
      this.createMediaForm(data, 0);
    });
    this._getSportList('');
  }
  // Get the sportsDetails FormArray
  get sportsDetails(): FormArray {
    return this.sportsForm.get('sportsDetails') as FormArray;
  }
  _getSportList(searchContent: any): void {
    let sportsDetailsValue = this.sportsDetails.controls[this.selectedSport - 1].value;
    let params: any = {
      scope: ['minimalData'],
      page: this.page,
      limit: 20,
    };
    if (searchContent) {
      params['search'] = searchContent.term;
    }
    if (sportsDetailsValue.sportId) {
      params['sortBy'] = sportsDetailsValue.sportId;
    }
    this._apiService.post(api._sportListing, params).subscribe({
      next: (res: any) => {
        if (res.data?.rows.length < 0) {
          this.page = this.page - 1;
        }
        if (this.page == 1) {
          // this.sportList=res.data?.rows.filter((x: { levels: string | any[]; }) => x?.levels.length)

          this.sportList = res.data?.rows;
        } else {
          res.data?.rows.map((item: any) => {
            this.sportList.push(item);
          });
        }

        if (sportsDetailsValue.sportId) {
          this.getlevelList(sportsDetailsValue.sportId);
        }
      },
    });
  }
  getlevelList(value: any) {
    if (!value) return;
    // Find the sport object from sportList
    const sport = (this.sportList || []).find((s: any) => s.id === value);
    this.levelList = sport?.levels || [];
  }
  // Create a form group for a single sport
  createSportForm(sport: any): FormGroup {
    return this.fb.group({
      Id: [sport?.id],
      sportId: [sport?.level?.sport.id],
      levelId: [sport?.level?.id], // Default levelId
      title: [sport?.title, [Validators.required], [NoWhitespaceValidator]],
      description: [sport?.description, Validators.required],
      dateOfActivity: [sport?.dateOfActivity ? new Date(sport?.dateOfActivity) : ''],
      location: [sport?.location],
      selfScore: [sport?.selfScore || sport?.level?.minFicorScore || 50],
      postMedias: this.fb.array([]),
      ficorScore: [sport?.level?.ficorScore],
      minFicorScore: [sport?.level?.minFicorScore || 50],
    });
  }
  onSubmit(): void {
    if (this.sportsForm.invalid) {
      this.showValidationMessage();
      return;
    }
    const payload = this.sportsForm.value.sportsDetails.map((sport: any) => ({
      id: sport.Id,
      // levelId: sport.levelId,
      title: sport.title,
      // dateOfActivity: sport.dateOfActivity ? formatDate(new Date(sport.dateOfActivity), 'yyyy-MM-dd', 'en-US') : '',
      description: sport.description,
      // location: sport.location,
      // postMedias: sport.postMedias.map((media: any) => ({
      //   mediaType: media.mediaType,
      //   mediaUrl: media.mediaUrl,
      // })),
    }));

    this._apiService.post(api._FeedPost, payload).subscribe({
      next: (res: any) => {
        this._toastr.success('Sport edit successfully.');
        this.activeOffcanvas.close(true);
      },
      error: (err: any) => {
        console.log(err);
      },
    });

    // }
  }
  closeModal(hasData: boolean): void {
    this.activeOffcanvas.close(hasData);
  }
  disableKeyPress(event: KeyboardEvent): void {
    event.preventDefault();
  }
  private showValidationMessage(): void {
    const validationMessageDuration = 5000;
    this.showError = true;
    setTimeout(() => (this.showError = false), validationMessageDuration);
  }

  subItems(index: number): FormArray {
    return this.sportsDetails.at(index).get('postMedias') as FormArray;
  }
  // Create a form group for media
  createMediaForm(image: any, index: any): void {
    const activities = this.getSport(index);
    activities.push(
      this.fb.group({
        Id: [image.id ?? ''],
        mediaUrl: [image?.mediaUrl],
        mediaType: [image?.mediaType],
        // _destroy:[false]
      }),
    );
  }
  getSport(sportIndex: number): FormArray {
    return this.sportsDetails.at(sportIndex).get('postMedias') as FormArray;
  }
  percent(value: any, ficorScore: any, minFicorScore: any) {
    return ((value - minFicorScore) / (ficorScore - minFicorScore)) * 100;
  }
  breakPoints(ficorScore: any, minFicorScore: any, index: any) {
    const step = (ficorScore - minFicorScore) / 5; // Divide into 4 equal parts
    let breakPoints = Array.from({ length: 5 }, (_, i) => Math.round(minFicorScore + step * i)); // Generate break points
    return breakPoints[index] != minFicorScore && breakPoints[index] != ficorScore ? breakPoints[index] : '';
  }
}
